import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSelector, useDispatch } from 'react-redux'
import { getOtpLogin, getOtpGenerate } from '../../store/features/OTPSlice'
import cookie from 'js-cookie'
import { Row, Col, Modal, Form } from 'react-bootstrap'
import  OTPInput,{ ResendOTP } from 'otp-input-react'
import OtpInput from 'react-otp-input';

import './otpstyles.css'
import Api from '../../Config/Api'
import MasterApi from '../../Config/MasterApi'
import Spinners from '../../component/Spinner/spinners';
import {getToday, getTime } from '../../component/Helper'

const renderButton = buttonProps => {
  return (
    <>
      <div className='smsOTP'>
        <div className='fs-12'>Tidak menerima SMS?</div>
        <div className='mb-10'>
          <button
            className='button-otp'
            disabled={buttonProps.disabled}
            onClick={buttonProps.onClick}
          >
            Kirim Ulang Kode OTP
          </button>
        </div>
      </div>
    </>
  )
}

const rendertime = rendertime => {
  let detik = rendertime
  let minute = Math.floor(detik / 60)
  let second = detik % 60

  if (second < 10) {
    return (
      <div style={{display:"none"}}>
      {/* <div> */}
        {minute} : 0{second}
      </div>
    )
  } else {
    return (
      <div style={{display:"none"}}>
      {/* <div> */}
        {minute} : {second}{' '}
      </div>
    )
  }
}

const sendOtp = (data,OTPexp,setOTPexp, Parameter, OTPVal, setOTPVal,setMinutes,setSeconds) => {
  const userAgent =
    navigator.userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || []
  let dataGenerate = {
    deviceId: `${userAgent[1]}`,
    userName: `${data.spajHeader?.userName}`,
    sentVia: 'sms',
    moduleApp: 'login',
    spajNumber: `${data.spajHeader.spajNumber}`
  }

  let dataz = Parameter.dataParameterApps.find(url =>{
    if (url.codeSetting == "OTP_EXPIRED"){
        // setOTPexp(url.valueSetting)
        return url.valueSetting
    }
  })

  let detik = dataz.valueSetting % 60
  let menit =  Math.floor(dataz.valueSetting/60)
  setMinutes(menit)
  setSeconds(detik)
  console.log(detik,menit, "nwer")
  Api.post(Api.routeHelper+MasterApi.otpGenerate, dataGenerate)
    .then(response => {
      const minute = Math.floor(dataz.valueSetting/60)
      // setOTPVal(Number(response.createDate.split("T")[1].split(".")[0].split(":")[1])+minute)
      const OTPVal = (Number(response.data.createDate.split("T")[1].split(".")[0].split(":")[1])+minute)
      setOTPVal(OTPVal)
      return response
    })
    .catch(err => {
      return err
    })
}

const Timer = (data) => {
  let seconds = data.seconds
  let setSeconds = data.setSeconds
  let setMinutes = data.setMinutes
  let minutes = data.minutes

  useEffect(()=>{
  let myInterval = setInterval(() => {
          if (seconds > 0) {
              setSeconds(seconds - 1);
          }
          if (seconds === 0) {
              if (minutes === 0) {
                  clearInterval(myInterval)
              } else {
                  setMinutes(minutes - 1);
                  setSeconds(59);
              }
          } 
      }, 1000)
      return ()=> {
          clearInterval(myInterval);
        };
  });

  return (
    <div style={{textAlign:"center"}}>
      { minutes === 0 && seconds === 0
          ? <div> 00:00</div> 
          : <div> {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</div> 
      }
      </div>
  )
}

const ReturnData = ({
  setMinutes,
  minutes,
  setSeconds,
  seconds,
  setOTPVal,
  OTPVal,
  setOTPexp,
  OTPexp,
  Parameter,
  reSentChance,
  setreSentChance,
  setMaxChance,
  maxChance,
  spaj,
  setOTP
}) => {
  let string
  let string2
  Parameter.dataParameterApps.map(params => {
    if (params.codeSetting == 'OTP_FALSE') {
      useEffect(()=>{
        setMaxChance(params.valueSetting)
      },[])
      string = (
        <div className='kesempatan mt-1' key={params.id}>
          {reSentChance}/{params.valueSetting}
        </div>
      )
    } else if (params.codeSetting == 'OTP_WAITING') {
      string2 = (
        <>
        <Timer
          Parameter={Parameter}
          setSeconds={setSeconds}
          seconds={seconds}
          setMinutes={setMinutes}
          minutes={minutes}  
        />
        <div
        key={params.id}
        className='mt-3 d-flex justify-content-center container-otp'
        >
          {' '}
          <ResendOTP
            maxTime={params.valueSetting}
            className={'timer-otp'}
            renderButton={renderButton}
            renderTime={rendertime}
            onResendClick={() => {
              sendOtp(spaj, OTPexp, setOTPexp, Parameter, OTPVal, setOTPVal, setMinutes, setSeconds)
              setOTP('')
            }}
          >
            {/* {' '} */}
          </ResendOTP>
        </div>
      </>
      )
    }
  })

  if (reSentChance >= maxChance) {
    return [
      string,
           //FOR DEV
    //   <ReCAPTCHA
    //     key={'captcha'}
    //     className='g-recaptcha'
    //     sitekey='6Ldp_T0gAAAAAF0U-pYdZF2UgtY0oDjdgqpzy6Ov'
    //     onChange={() => setreSentChance(0)}
    //   />
        //FOR UAT PROD
        <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
          <ReCAPTCHA
            key={'captcha'}
            className='g-recaptcha'
            sitekey='6LdsYG8gAAAAAFL4MoWjadi3DVNfbMPnFDa5BYIo'
            onChange={() => {
              setreSentChance(0)
              sendOtp(spaj, OTPexp, setOTPexp, Parameter,OTPVal,setOTPVal,setMinutes,setSeconds)
              setOTP('')
            }}
          />
        </div>

    ]
  } else {
    return [string, string2]
  }
}

const Otp = () => {
  let navigate = useNavigate()
  let [errMsg, setErrMsg] = useState("")
  let [showHide, setShowHide] = useState(false)
  let [digitErrorOTP,setDigitErrorOTP] = useState(false)
  let [notMatchOTP,setNotMatchOTP] = useState(false)
  let [errOTPExp, setErrOTPExp] = useState(false)
  const dispatch = useDispatch()
  const [OTP, setOTP] = useState('')
  const [OTPAwal, setOTPAwal] = useState(0)
  const [loading, setLoading] = useState(false);
  const [reSentChance, setreSentChance] = useState(0)
  const [OTPVal, setOTPVal] = useState()
  const [OTPexp, setOTPexp] = useState(0)
  const [OTPxpEf, setOTPxpEf] = useState(0)
  const { SPAJs } = useSelector(state => state.SPAJs)
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const userAgent =
    navigator.userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || []
  const { Parameter } = useSelector(state => state.Params)
  const [checkTerm, setCheckTerm] = useState(false)
  const [maxChance, setMaxChance] = useState('3')
  const [reachBottom, setReachBottom] = useState(false)
  const [errorOtpDigit, setOtpDigit] = useState(false)
  const innerRef = useRef()

  useEffect(() => {
    let dataGenerate = {
      deviceId: `${userAgent[1]}`,
      userName: `${SPAJs.spajHeader?.userName}`,
      sentVia: 'sms',
      moduleApp: 'login',
      spajNumber: `${SPAJs.spajHeader.spajNumber}`
    }

    

    let datas = Parameter.dataParameterApps.find(url =>{
      if (url.codeSetting == "OTP_EXPIRED"){
          // setOTPAwal(url.valueSetting)
          return url.valueSetting
      }
    })

    let detik = datas.valueSetting % 60
    let menit =  Math.floor(datas.valueSetting/60)
    setSeconds(detik)
    setMinutes(menit)
    // UNCOMMENT THIS FOR UAT/PROD
    dispatch(getOtpGenerate(dataGenerate)).then(res => {
      const minute = Math.floor(datas.valueSetting/60)
      const OTPVal = (Number(res.payload.data.createDate.split("T")[1].split(".")[0].split(":")[1])+minute)
      setOTPVal(OTPVal)
    }).catch(err => {
       return err
    });
  }, [])

  const handleOtpLogin = (e) => {
    e.preventDefault()
    let dataLogin = {
      deviceId: `${userAgent[1]}`,
      deviceType: `${userAgent[1]}`,
      userName: `${SPAJs.spajHeader.userName}`,
      spajNumber: `${SPAJs.spajHeader.spajNumber}`,
      otp: OTP
    }

    if (dataLogin.otp.length != 6) {
      setDigitErrorOTP(true)
    } else if (!dataLogin.otp) {
      setNotMatchOTP(true)
    } else if (parseInt(getTime().split(':')[1]) > OTPVal){
      setErrOTPExp(true)
    }
     else {
      setLoading(true)
      dispatch(getOtpLogin(dataLogin)).then(res => {
        if (res.payload.status === 'ERROR' || res.payload.status === false) {
          setLoading(false)
          let msg = res.payload.errMsg
          setErrMsg(msg)
          res.payload.status === 'ERROR' && setNotMatchOTP(true)
          setOTP('')
          res.payload.status === 'ERROR' && setreSentChance(reSentChance +  1)
        } else {
          setLoading(false)
          // cookie.set('accessToken', res.payload.token, { expires: 1 })
          // cookie.set('refreshToken', res.payload.RefreshToken, { expires: 1 })
          localStorage.setItem("TOKEN", JSON.stringify(res.payload.data));
          sessionStorage.setItem("TOKEN_SESSION", JSON.stringify(res.payload.data));
          showTerms()
          }
      })
    }
  }

  const nextPage = () => {
    if (checkTerm) {
      hideTerms()
      navigate('/landing-page')
    } else {
      alert('Check the term')
    }
  }
  const showTerms = e => {
    setShowHide(true)
  }

  const hideTerms = e => {
    setShowHide(false)
    setCheckTerm(false)
  }

  const handleOnScroll = () => {
    if (innerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = innerRef.current;
        if (scrollTop + clientHeight >= (scrollHeight - 10)) {
          setReachBottom(true);
        }
      }
  }
  const setPopupError = () =>{
    let errors = false
    setErrOTPExp(errors)
    setNotMatchOTP(errors)
    setDigitErrorOTP(errors)
  }

  return (
    <>
      {loading == true && <Spinners />}
      <div>
        <Row className='g-0 welcome-container'>
          <Col xs={12} sm={12} md={12} lg={6}>
            <div className='left-container position-relative'>
              <div className='icon-container'>
                <img
                  src='images/generali-white.png'
                  className='icon-gen size-logo'
                />
              </div>
              <div className='logo-posisi'>
                <img src="images/generali-white.png" className='size-logo' />
              </div>
              <div className='position-cardfooter-otp'>
                <div className='card-container-otp shadow-lg'>
                  <form onSubmit={(e) => handleOtpLogin(e)}>
                    <div className='bold fs-16 text-center'>
                      Masukkan Kode OTP
                    </div>
                    <div className='mt-OTPInput2 mt-2'>
                      <div className='fs-12 text-center'>
                        Silakan Masukkan kode OTP yang telah kami kirimkan ke
                        Nomor Handphone Anda di {SPAJs.spajHeader?.phoneNo}, dan email {SPAJs.spajHeader?.userEncrypt}
                      </div>
                    </div>
                    <div className='mt-2 d-flex justify-content-center'>

                    <OtpInput
                      value={OTP}
                      onChange={setOTP}
                      numInputs={6} // Number of OTP input boxes
                      inputType={'tel'}
                      inputStyle={{
                        width: '50%',
                        height: '50px',
                        margin: '5px',
                        fontSize: '18px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                      renderInput={(props) => <input {...props} />}
                    />
                    </div>
                  
                    <ReturnData
                      setMinutes={setMinutes}
                      minutes={minutes}
                      setSeconds={setSeconds}
                      seconds={seconds}
                      setOTPVal={setOTPVal}
                      OTPVal={OTPVal}
                      OTPexp={OTPexp}
                      setOTPexp={setOTPexp}
                      Parameter={Parameter}
                      reSentChance={reSentChance}
                      setreSentChance={setreSentChance}
                      setMaxChance={setMaxChance}
                      maxChance={maxChance}
                      spaj={SPAJs}
                      setOTP={setOTP}
                    />
                    <div className='mt-2'>
                      <button
                        className='button-red'
                        type='submit'
                        disabled={reSentChance >= maxChance}
                      >
                        Login
                      </button>
                    </div>
                  </form>
                </div>

              </div>
              <div className='logo-link-otp'>
                <div className='link-items'>www.generali.co.id</div>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <div className='logo-posisi-potrait'>
            <img src="images/header2.png" className='size-logo' />
            </div>
            <div>
              <img src='images/loginpage.jpg' className='ilustration imageOtp1'/>
            </div>
          </Col>
        </Row>
      </div>

      <Modal dialogClassName="my-modalcustom-otp" centered className='fs-14' show={showHide}>
        <Modal.Header closeButton onClick={() => hideTerms()}>
          <Modal.Title>SYARAT DAN KETENTUAN</Modal.Title>
        </Modal.Header>
        <Modal.Body onScroll={handleOnScroll} ref={innerRef} className="modal-body">
            <p>Perjanjian Lisensi Pengguna Akhir – Untuk Nasabah Generali Indonesia</p>
            <p>Perjanjian Lisensi Pengguna Akhir (“Perjanjian”)</p>
            <p>Mohon membaca seluruh ketentuan Perjanjian ini.</p>
            <p>
              Syarat dan ketentuan Perjanjian sebagaimana diuraikan di bawah ini
              akan digunakan sebagai dasar penggunaan Situs dan
              layanan-layanannya serta teknologi terkait yang disediakan oleh
              Generali Indonesia kepada Anda.
            </p>
            <p>
              Sebelum menggunakan situs ini, Anda wajib membaca dan memahami
              Perjanjian ini dengan seksama.
            </p>
            <p>
              Selanjutnya, dengan menekan “Saya Menerima” maka Anda telah setuju
              pada syarat dan ketentuan Perjanjian ini dan pada Kebijakan
              Privasi kami. Apabila Anda tidak menyetujui syarat dan ketentuan
              Perjanjian ini, maka Anda tidak diperbolehkan untuk mengakses
              Situs ini atau layanan-layanannya.
            </p>
            <p>1. Definisi</p>
            <p>
              1.1. “Situs” adalah Situs yang dibuat dan dimiliki oleh Generali
              Indonesia, yang berjalan pada sistem operasi perangkat
              telekomunikasi.
            </p>
            <p>
              1.2. “Generali Group” adalah Assicurazioni Generali, anak
              perusahaannya dan perusahaan afiliasinya.
            </p>
            <p>
              1.3. “Generali Indonesia” adalah PT Asuransi Jiwa Generali
              Indonesia yang berlokasi di Generali Tower lantai 7, Gran Rubina
              Business Park Kawasan Rasuna Epicentrum, Jalan HR Rasuna Said
              Kavling C-22.
            </p>
            <p>1.4. “Kami” adalah Generali Indonesia.</p>
            <p>
              1.5. “Anda” adalah pihak yang mengunduh dan menggunakan Situs ini.
            </p>
            <p>
              2. Kebijakan Privasi dan Keamanan Generali Indonesia Tujuan Situs
              ini adalah untuk menyediakan mekanisme kepada Anda agar memudahkan
              dan memaksimalkan peran dan fungsi Anda sebagai Nasabah Generali
              Indonesia. Dengan menyetujui Perjanjian ini, maka Anda akan
              terikat oleh Kebijakan Privasi Generali Indonesia, yang dapat
              ditemukan dalam situs <a href="http://www.generali.co.id/en/privacy-policy">http://www.generali.co.id/en/privacy-policy</a>
            </p>
            <p>
              3. Setiap biaya yang timbul terkait penggunaan layanan Situs ini,
              termasuk biaya data dari penyedia layanan perangkat telekomunikasi
              Anda akan dibebankan kepada Anda.
            </p>
            <p>
              4. Situs ini tidak boleh digunakan pada perangkat atau sistem
              operasi yang telah dimodifikasi di luar perangkat telekomunikasi
              atau sistem operasi yang didukung oleh vendor atau konfigurasi
              yang bergaransi. Termasuk perangkat yang “jail-broken” atau
              “rooted”. Untuk tujuan dari Perjanjian ini, perangkat yang
              jail-broken atau rooted adalah perangkat yang telah dibebaskan
              dari pembatasan yang diberikan pada perangkat tersebut oleh
              penyedia layanan perangkat telekomunikasi dan produsen perangkat
              telekomunikasi tanpa persetujuan mereka.
            </p>
            <p>5. Tidak Ada Jaminan</p>
            <p>
              5.1. Situs ini disediakan tanpa adanya representasi, jaminan atau
              perjanjian bahwa akses pada Situs tidak akan terganggu atau tidak
              ada keterlambatan atau kesalahan teknis diluar kendali Generali
              Indonesia. Kami juga tidak dapat menjamin bahwa tidak akan ada
              virus atau kontaminasi lainnya atau hal-hal yang bersifat merusak
              atau gangguan terindentifikasi kejahatan atau tidak akan ada
              kerusakan yang terjadi pada perangkat telekomunikasi Anda. Anda
              bertanggung jawab untuk melakukan proteksi dan membuat cadangan
              data dan/atau perangkat dan melakukan tindakan pencegahan yang
              tepat dengan memindai virus-virus komputer atau hal-hal lainnya
              yang bersifat merusak, sehingga Kami tidak bertanggung jawab jika
              Anda mengalami kerugian akibat dari hal-hal yang disebutkan di
              atas.
            </p>
            <p>
              5.2. Kami juga tidak bertanggung jawab atas perangkat lunak pihak
              ketiga apapun yang digunakan untuk menghubungkan dengan Situs.
            </p>
            <p>6. Merek Dagang dan Hak Cipta</p>
            <p>
              6.1. “Generali” merupakan merek dagang dari Generali Group dan
              semua hak dari dan untuk Generali yang ada di dalam Generali
              Group. Anda tidak boleh menggunakan atau meniru merek dagang
              Generali, logo atau nama merk Generali. Hak cipta di dalam
              halaman, layar, informasi, dan semua material dalam pengaturan,
              termasuk di dalam Situs merupakan hak milik atau telah dilisensi
              oleh kami atau Generali Group terkecuali dinyatakan lain.
            </p>
            <p>
              6.2. Anda dilarang menggunakan Situs untuk tujuan yang tidak sah,
              menghina, memfitnah, tidak patut atau mengancam.
            </p>
            <p>
              6.3. Tunduk pada syarat dan ketentuan Perjanjian ini, Generali
              Indonesia dengan ini memberi Anda hak yang tidak eksklusif dan
              tidak dapat dialihkan untuk menggunakan Situs ini untuk
              layanan-layanan yang berhubungan dengan Generali Indonesia
              dan/atau Generali Group.
            </p>
            <p>
              6.4 Anda tidak dapat menggunakan hak, kuasa, dan kepentingan dari
              dan ke dalam Situs, termasuk, tetapi tidak terbatas pada semua hak
              kekayaan intelektual di dalam Situs. Perjanjian ini bukan
              perjanjian penjualan, dan tidak ada kuasa, hak kekayaan
              intelektual, atau hak kepemilikan atas Situs yang dialihkan kepada
              Anda sesuai dengan Perjanjian ini. Anda mengetahui dan menyetujui
              bahwa Situs dan seluruh ide, metode, algoritma, rumus, proses, dan
              konsep yang digunakan untuk mengembangkan atau menggabungkan ke
              dalam Situs, semua pembaruan dan pemutakhiran di masa depan, dan
              semua perbaikan, revisi, koreksi, dan pembaruan data base dan
              pembaruan yang lainnya di dalam, dan untuk Situs, semua hasil yang
              diciptakan berdasarkan salah satu hal di atas adalah merupakan
              rahasia dagang dan hak milik Generali Indonesia, yang memiliki
              nilai komersial yang besar bagi Generali Indonesia.
            </p>
            <p>7. Tanggung Jawab</p>
            <p>
              7.1. Anda bertanggung jawab atas seluruh klaim, kerusakan dan
              biaya yang timbul dari:
            </p>
            <p>(i) penggunaan Situs Anda</p>
            <p>(ii) Informasi yang Anda berikan kepada kami</p>
            <p>
              (iii) Setiap pelanggaran yang Anda lakukan atas Perjanjian ini,
              setiap kekayaan intelektual atau hak lain dari setiap orang atau
              entitas.
            </p>
            <p>
              7.2. Anda bertanggung jawab sepenuhnya atas hal-hal sebagai
              berikut:
            </p>
            <p>
              (i) Perlindungan yang memadai atas data dan peralatan, yang
              termasuk tetapi tidak terbatas pada prosedur yang tercantum pada
              Tips Keamanan yang dapat ditemukan pada Situs
            </p>
            <p>
              (ii) Melakukan tindakan pencegahan yang tepat dengan memindai
              virus-virus komputer atau hal-hal lainnya yang bersifat merusak;
            </p>
            <p>
              (iii) Membebaskan Generali Indonesia untuk memberikan ganti rugi
              bila ada tuntutan dari pihak ketiga, kerugian atau biaya apapun
              yang terjadi baik secara langsung maupun tidak langsung, termasuk
              namun tidak terbatas pada biaya penasehat hukum dan/atau biaya
              perkara; dan
            </p>
            <p>
              (iv) Anda harus mengunci dengan password layar perangkat
              telekomunikasi dan harus segera melaporkan ke Generali Indonesia
              apabila kehilangan perangkat telekomunikasi Anda.
            </p>
            <p>
              8. Privasi dan Pengumpulan Informasi Personal atau Informasi
              Sistem
            </p>
            <p>
              8.1. Situs ini, termasuk teknologi pendukung dan pihak-pihak yang
              bekerjasama dengan Generali Indonesia dalam penggunaan Situs ini,
              akan mengumpulkan dan/atau menyimpan Data pribadi Anda dan pihak
              lain yang berhubungan dengan Anda, termasuk termasuk tetapi tidak
              terbatas pada nama user, alamat, alamat e-mail, tanggal lahir,
              rincian pembayaran, pendapatan, catatan medis, anggota keluarga
              (secara kolektif, “Data”).
            </p>
            <p>
              8.2. Pengumpulan Data ini diperlukan agar penggunaan Situs ini
              dapat berjalan dengan baik dan sesuai kebutuhan Anda.{' '}
            </p>
            <p>
              8.3. Anda tidak diperbolehkan mengirim, menggandakan,
              menghilangkan, menghapus, dan/atau memodifikasi Data tanpa
              persetujuan dari pemilik Data.
            </p>
            <p>
              8.4 Dengan menerima Perjanjian ini, maka Anda telah memberikan
              persetujuan kepada Generali Indonesia untuk menggunakan/memberikan
              informasi mengenai Data yang telah diberikan/tersedia di Situs
              atau sarana terkait lainnya kepada pihak lain yang memiliki
              hubungan kerjasama dengan Generali dalam rangka penggunaan Situs
              ini, termasuk kepada perusahaan penyelenggara tanda tangan
              elektronik dan digital.
            </p>
            <p>9. Lain-lain</p>
            <p>
              9.1. Dalam pelaksanaan Situs ini, Kami dapat melakukan kerjasama
              dengan pihak lain untuk melaksanakan hak dan kewajiban kami dalam
              Perjanjian ini. Namun, Anda tidak dapat mengalihkan hak atau
              kewajiban Anda dalam Perjanjian ini kepada pihak lainnya.
            </p>
            <p>
              9.2. Jika terdapat keputusan dari otoritas yang berwenang bahwa
              sebagian dari ketentuan Perjanjian ini tidak berlaku, maka
              ketentuan lain dari Perjanjian ini akan tetap berlaku sepenuhnya.
            </p>
            <p>
              9.3. Apabila Anda memiliki pertanyaan-pertanyaan tentang Situs
              ini, silahkan menghubungi Customer Care Generali Indonesia di:
            </p>
            <ul type="none">
              <li>PT Asuransi Jiwa Generali Indonesia</li>
              <li>Generali Tower 7th Floor</li>
              <li>Gran Rubina Business Park</li>
              <li>Kawasan Rasuna Epicentrum</li>
              <li>JL HR Rasuna Said Kavling C-22, Jakarta 12940</li>
              <li>Telepon : 1500037</li>
              <li>Email : care@generali.co.id</li>
            </ul>
            <p>10. Perubahan</p>
            <p>
              10.1. Perubahan atas Syarat dan Ketentuan dalam Perjanjian ini
              dapat dilakukan perubahan dengan memberikan notifikasi kepada Anda
              sebelum perubahan terjadi pada layar login Situs kami.
            </p>
            <p>11. Pengakhiran</p>
            <p>
              11.1. Kami dapat mengakhiri Perjanjian ini dengan segera jika:
            </p>
            <p>
              (i) Anda melakukan pelanggaran Syarat dan Ketentuan Perjanjian ini
              atau dapat diduga Anda melakukan tindakan kecurangan, dimana Anda
              seharusnya tidak berhak mengunduh Situs ini;
            </p>
            <p>
              (ii) Generali Indonesia atau perusahaan Generali Group lainnya,
              terkena tindakan atau kecaman dari pemerintah, regulator atau
              lembaga penegak hukum.
            </p>
            <p>
              11.2. Kami dapat mengakhiri Perjanjian ini untuk alasan lainnya
              dengan memberi Anda notifikasi pada layar login Situs.
            </p>
            <p>
              11.3. Jika Perjanjian ini berakhir, maka Anda wajib untuk
              menghapus Situs ini dari perangkat telekomunikasi.{' '}
            </p>
            <p>
              11.4. Generali Indonesia dan Anda Sepakat bahwa untuk
              mengesampingkan Pasal 1266 Kitab Undang-Undang Hukum Perdata
              sehingga pegakhiran Perjanjian ini tidak memerlukan putusan
              Pengadilan.
            </p>
            <p>12. Yurisdiksi</p>
            <p>
              12.1. Perjanjian ini diatur oleh hukum Negara Republik Indonesia.
            </p>
          <Form>
            <Form.Check
              key={`default-checkbox`}
              className=' mt-1 mb-3 me-5'
              // disabled
              type={'checkbox'}
              id={`default-checkbox`}
              disabled={!reachBottom}
              label={`Saya telah membaca dan memahami Syarat dan Ketentuan diatas`}
              value={checkTerm}
              onChange={() => setCheckTerm(!checkTerm)}
            />
          </Form>
          <button
            className={checkTerm ? 'button-red' : 'button-red-disabled'}
            disabled={!checkTerm}
            type='submit'
            onClick={e => nextPage()}
          >
            Saya Menerima
          </button>
        </Modal.Body>
        {/* <Modal.Footer>


        </Modal.Footer> */}
      </Modal>
      <Modal dialogClassName="modalcustom" centered show={digitErrorOTP}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>OTP harus di isi dengan 6 digit</p>
                      <div onClick={() => setPopupError()}>
                          <div className="buttonkembalimodal">
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>
      <Modal dialogClassName="modalcustom" centered show={notMatchOTP}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>{errMsg}</p>
                      <div onClick={() => setPopupError()}>
                          <div className="buttonkembalimodal">
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>
      <Modal dialogClassName="modalcustom" centered show={errOTPExp}>
          <Modal.Body style={{margin: 25}}>
              <div className='d-flex flex-column justify-content-center align-items-center'>
                  <p className='fs-15 text-center'>OTP Expired</p>
                      <div onClick={() => setPopupError()}>
                          <div className='buttonkembalimodal'>
                              <button>OK</button>
                          </div>
                      </div>
              </div>
          </Modal.Body>
      </Modal>
    </>
  )
}

export default Otp